export const IS_SER_DEFAULT_MSG_SET = 'IS_SER_DEFAULT_MSG_SET';